function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "pencil-icon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7071 0.292893C14.3166 -0.0976311 13.6834 -0.0976311 13.2929 0.292893L10.293 3.29279C10.293 3.29283 10.2929 3.29286 10.2929 3.29289C10.2929 3.29293 10.2928 3.29296 10.2928 3.29299L0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.5523 0.447715 18 1 18H4C4.26522 18 4.51957 17.8946 4.70711 17.7071L14.7068 7.70739C14.7069 7.70729 14.707 7.7072 14.7071 7.70711C14.7072 7.70701 14.7073 7.70692 14.7074 7.70683L17.7071 4.70711C18.0976 4.31658 18.0976 3.68342 17.7071 3.29289L14.7071 0.292893ZM14 5.58579L15.5858 4L14 2.41421L12.4142 4L14 5.58579ZM11 5.41421L2 14.4142V16H3.58579L12.5858 7L11 5.41421Z",
  fill: "#908E8E"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.acf5ef68.svg";
export { ForwardRef as ReactComponent };